/** How wide each side's fade is, in points: 0 shows that side's content whole. */
export type HorizontalScrollEdgeFadeWidths = { left: number; right: number };

/** Points of content hidden past a side at which that side's fade reaches its full width. */
const FULL_FADE_HIDDEN_POINTS = 6;

function getFadeWidth(hiddenPoints: number, width: number): number {
  "worklet";
  return width * Math.min(1, Math.max(0, hiddenPoints / FULL_FADE_HIDDEN_POINTS));
}

/**
 * Each side fades whenever content hides past it: across its full `width` once a few points are
 * hidden, and narrower only within those last few points of the scroll, so it never pops. The
 * content always dissolves to nothing right at the edge, so a pill cut off by even a point never
 * shows the flat cut the viewport makes in it. Content that fits fades neither side. Runs on the
 * UI thread, from the shared values `useHorizontalScrollEdges` keeps.
 */
export function getHorizontalScrollEdgeFadeWidths({
  contentWidth,
  scrollX,
  viewportWidth,
  width,
}: {
  contentWidth: number;
  scrollX: number;
  viewportWidth: number;
  width: number;
}): HorizontalScrollEdgeFadeWidths {
  "worklet";
  return {
    left: getFadeWidth(scrollX, width),
    // Negative when the content fits, which gives the right side no fade at every offset.
    right: getFadeWidth(contentWidth - viewportWidth - scrollX, width),
  };
}
